import cx from "classnames";
const Input = ({
  value,
  label,
  name,
  placeholder,
  type,
  onChange,
  onBlur,
  readOnly,
  disabled,
  icon = false,
  className
}) => <div className={cx({
  relative: icon
})} data-sentry-component="Input" data-sentry-source-file="Input.jsx">
    {label && <label htmlFor="input-field" className="mb-2 block text-sm font-medium text-[#5E5E5E]">
        {label}
      </label>}
    {icon && <span className="absolute start-4 top-1/2 block -translate-y-1/2">
        {icon}
      </span>}
    <input type={type} readOnly={readOnly} disabled={disabled} value={value} name={name} onBlur={onBlur} placeholder={placeholder} onChange={onChange} className={cx(`border-supportiveDarkGray text-supportiveBlack placeholder:text-supportiveGray4 read-only:bg-supportiveDarkGray focus:outline-icon-color disabled:bg-supportiveThinGray block h-9 w-full appearance-none border bg-white px-4 text-base font-medium leading-tight placeholder:text-base focus:bg-white md:h-11 ${className}`, {
    "ps-12": icon
  })} />
  </div>;
export default Input;